import React from 'react';
import styled from 'styled-components';

import PlzSVG from '../../../images/plz.inline.svg';
import OtherSVG from '../../../images/custom-products/solo/arkansas-state-outline-necktie.inline.svg';

const svgs = [
    {
        slug: 'army-aviation-necktie',
        solo: <OtherSVG />,
        lifestyle: <PlzSVG />,
    },
];

const SVGContainerContainer = styled.div`
    svg {
        .st0 {
            fill: ${(props) => props.colors.primary_color.code};
        }
        .st1 {
            fill: ${(props) => props.colors.secondary_color.code};
        }
        .st2 {
            fill: ${(props) => props.colors.accent_1.code};
        }
    }
`;

const SVGContainer = ({ currentPalette, currentSVG }) => {
    return (
        <SVGContainerContainer colors={currentPalette}>
            {svgs &&
                svgs.map((item) => {
                    return (
                        <>
                            {currentSVG === 0 ? (
                                <div className="image-wrapper solo">
                                    {item.solo}
                                </div>
                            ) : (
                                <div className="image-wrapper lifestyle">
                                    {item.lifestyle}
                                </div>
                            )}
                        </>
                    );
                })}
        </SVGContainerContainer>
    );
};

export default SVGContainer;
